import PropTypes from "prop-types"
import { includes } from "lodash"
import OPTooltip from "components/material/tooltip"
import { getHighlightedText, NON_SEARCHABLE_SECONDARY_TYPES } from "../helpers"

export function SecondaryText({ secondary, detail, type, value }) {
  if (!detail) return getHighlightedText(secondary, value)

  const secondaryElement = includes(NON_SEARCHABLE_SECONDARY_TYPES, type) ? secondary : getHighlightedText(secondary, value)
  const detailElement = <span className="item-detail">{getHighlightedText(detail, value)}</span>
  return <span className="text-overflow-dynamic-container">
    <span className="text-overflow-dynamic-ellipsis">{secondaryElement} - <OPTooltip placement="bottom-start" classes={{ popper: "large-tooltip" }} title={detailElement}>{detailElement}</OPTooltip></span>
  </span>
}

SecondaryText.propTypes = {
  secondary: PropTypes.string.isRequired,
  detail: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}
